module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basic-box__row-wrap"
  }, [_c('div', {
    staticClass: "basic-box__row hr"
  }, [_c('div', {
    staticClass: "basic-box__row-inner"
  }, [_c('div', {
    staticClass: "basic-box__row-item basic-box__row-item_time"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("time")(_vm.event.time.$date.$numberLong, 'x')) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "basic-box__row-item basic-box__row-item_avatar-wrap"
  }), _vm._v(" "), _c('div', {
    staticClass: "basic-box__row-item basic-box__row-item_name"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("eventMessage")(_vm.event)) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "basic-box__row-item basic-box__btns"
  }, [_c('button', {
    staticClass: "basic-box__btn basic-box__btn_confirm",
    on: {
      "click": function($event) {
        _vm.sendAnswer(_vm.event, 'approve')
      }
    }
  }, [_vm._v("\n\t\t\t\t\tПодтвердить\n\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "basic-box__btn basic-box__btn",
    on: {
      "click": function($event) {
        _vm.sendAnswer(_vm.event, 'reject')
      }
    }
  }, [_vm._v("\n\t\t\t\t\tОтменить\n\t\t\t\t")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5d6f640"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotificationItem.vue
// module id = 653
// module chunks = 0